module.exports = __webpack_public_path__ + "img/Fond-tarifs.ffb4b160.jpg";